import { createStyles, makeStyles } from '@material-ui/core/styles';
import type { Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    return createStyles({
        checkedIcon: {
            display: 'flex',
            justifyContent: 'space-between',
            '&:first-of-type': {
                flexGrow: 1,
            },
            '& svg': {
                color: 'transparent',
                marginLeft: theme.spacing(2),
            },
            '&[aria-selected="true"]': {
                '& svg': {
                    color: theme.palette.success.main,
                },
            },
            '&[data-focus="true"]': {
                '& svg': {
                    color: theme.palette.action.focus,
                },
            },
            '&:active': {
                '& svg': {
                    color: theme.palette.action.active,
                },
            },
            '&[aria-disabled="true"]': {
                '& svg': {
                    color: theme.palette.action.disabled,
                },
            },
        },
    });
};

export default makeStyles(styles, { name: 'MuiMenuOption' });
